// Generated by Melange

import H2ModuleCss from "./h2.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import Clsx from "clsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = H2ModuleCss;

function H2(Props) {
  let children = Props.children;
  let className = Props.className;
  let id = Props.id;
  let tmp = {
    className: Clsx(className, css.root)
  };
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  return JsxRuntime.jsx("h2", tmp);
}

const make = H2;

export {
  make,
}
/* css Not a pure module */
